<template>
  <div>
    <Header/>
    <Navigationzj/>
    <div class="h_zp_zx">
      <div class="index_about">
        <router-link :to="{path:'/'}">
          <div class="img_bj"></div>
        </router-link>
        <div class="about">
          <router-link :to="{path:'/'}">
            <div class="float_r text">
              <div class="biaoti">走进<span>亚森宏远</span></div>
              <div class="img">
                <img src="../../assets/repair/about.png">
              </div>
              <div class="bt">北京亚森宏远技术服务有限公司</div>
              <div class="xian"></div>
              <p style="text-indent: 2em;">北京亚森宏远技术服务有限公司是工业自动化生产设备的专业维修公司。公司成立于2010年，作为工业自动化领域的芯片级电路板维修机构，业务领域涵盖电力、石化、汽车制造、汽车配件配套生产、橡胶轮胎、包装机械、食品饮料、化工、医疗器械等诸多行业。</p>
              <p style="text-indent: 2em;">国内领先的电气维修技术服务及解决方案提供商。凭借高效的服务能力，超过17年服务于众多客户的经验积累，成功成为众多知名企业信任的电气维修服务提供商。</p>
            </div>
            <div class="clear"></div>
          </router-link>
          <router-link :to="{path:'/'}" class="more"></router-link>
        </div>
      </div>
      <div class="index_product">
        <div class="center">
          <div class="index_title">
              <div class="h6"><span>亚森宏远</span>维修项目</div>
              <p>专业从事各类工业电路板维修的企业！</p>
          </div>
          <div class="fenlei">
            <div class="left">
              <p>项目分类</p>
            </div>
            <div class="right">
              <el-carousel arrow="always" indicator-position="none" :autoplay="false" height="70px">
                <el-carousel-item>
                  <div class="item-label">
                    <div :class="{on:showinfo === 1}" class="swiper-slide" @click="click_tab(1)">测试数据维修</div>
                    <div :class="{on:showinfo === 2}" class="swiper-slide" @click="click_tab(2)">测试数据维修</div>
                    <div :class="{on:showinfo === 3}" class="swiper-slide" @click="click_tab(3)">测试数据维修</div>
                    <div :class="{on:showinfo === 4}" class="swiper-slide" @click="click_tab(4)">测试数据维修</div>
                    <div :class="{on:showinfo === 5}" class="swiper-slide" @click="click_tab(5)">测试数据维修</div>
                  </div>
                </el-carousel-item>
                <el-carousel-item>
                  <div class="item-label">
                    <div :class="{on:showinfo === 6}" class="swiper-slide" @click="click_tab(6)">测试数据维修</div>
                    <div :class="{on:showinfo === 7}" class="swiper-slide" @click="click_tab(7)">测试数据维修</div>
                    <div :class="{on:showinfo === 8}" class="swiper-slide" @click="click_tab(8)">测试数据维修</div>
                    <div :class="{on:showinfo === 9}" class="swiper-slide" @click="click_tab(9)">测试数据维修</div>
                    <div :class="{on:showinfo === 10}" class="swiper-slide" @click="click_tab(10)">测试数据维修</div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="label_page">
            <div class="label_page_each" style="display: block;">
              <router-link v-for="(item,index) in 3" :key="index" :to="{path:'/RepairDetail'}" class="float_l">
                <div class="img">
                  <img src="http://www.qdkeyue.com/uploads/image/20190507/1557227879.jpg">
                </div>
                <div class="h6">测试数据维修</div>
                <div class="p">测试数据维修</div>
              </router-link>
              <div class="clear"></div>
            </div>
          </div>
          <!-- 产品推荐 -->
          <div class="product">
            <router-link v-for="(item,index) in 3" :key="index" :to="{path:'/RepairDetail'}" class="float_l">
              <div class="xq">
                <div class="h6">测试数据维修</div>
                <div class="p">测试数据维修</div>
                <div class="xian"></div>
                <div class="img">
                  <img src="http://www.qdkeyue.com/uploads/image/20190625/1561480598.jpg">
                </div>
              </div>
            </router-link>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div class="advantage">
        <div class="center">
          <div class="index_title">
            <div class="h6">亚森宏远<span>5</span>大优势</div>
            <p>亚森宏远 — 专业维修，值得信赖，您身边的工控维修专家！</p>
          </div>
          <img class="advantage_img" src="../../assets/repair/advantage.png">
          <div class="each_item each_item1">
            <div class="float_r bt">技术精湛</div>
            <div class="float_l nr">本公司已拥有一支技术精湛、经验丰富的维修队伍</div>
            <div class="clear"></div>
          </div>
          <div class="each_item each_item2">
            <div class="float_r bt">专业设备</div>
            <div class="float_l nr">本公司拥有先进的各种专业测试、分析，修复设备</div>
            <div class="clear"></div>
          </div>
          <div class="each_item each_item3">
            <div class="bt">配件充足</div>
            <div class="nr">充足的库存配件，大量维修相关技术人员为您保驾护航</div>
            <div class="clear"></div>
          </div>
          <div class="each_item each_item4">
            <div class="float_r nr">公司与很多大型企业长期合作，保证价格优惠</div>
            <div class="float_l bt">价格合理</div>
            <div class="clear"></div>
          </div>
          <div class="each_item each_item5">
            <div class="float_r nr">公司提供一对一客户服务，专心为客户排忧解难</div>
            <div class="float_l bt">完善售后</div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div class="index_service">
        <div class="center">
          <div class="index_title">
              <div class="h6"><span>亚森宏远</span>服务流程</div>
              <p>对于所有经我们维修的驱动器及电路板，伺服电机，保修三个月</p>
          </div>
          <div class="icon icon1">
              <div class="float_l">
                <img src="../../assets/repair/icon1.png">
                <p>客户来单</p>
              </div>
              <div class="float_l">
                <img src="../../assets/repair/icon2.png">
                <p>客户沟通确定异常</p>
              </div>
              <div class="float_l">
                <img src="../../assets/repair/icon3.png">
                <p>修好客户取走或快递</p>
              </div>
              <div class="float_l">
                <img src="../../assets/repair/icon4.png">
                <p>竣工验收</p>
                <p>给出服务评价</p>
              </div>
              <div class="clear"></div>
          </div>
          <div class="icon icon2">
            <div class="float_l">
              <img src="../../assets/repair/icon5.png">
              <p>运用系统测试台检测故障</p>
            </div>
            <div class="float_l">
              <img src="../../assets/repair/icon6.png">
              <p>向客户报价</p>
            </div>
            <div class="float_l">
              <img src="../../assets/repair/icon7.png">
              <p>不修发货前测试客户协商方案</p>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div class="cooperation">
        <div class="center">
          <div class="index_title">
            <div class="h6"><span>品牌合作</span>维修展示</div>
            <p>与大企业长期合作，树立了良好的口碑，客户遍及全国各地！</p>
          </div>
          <div class="certify">
            <el-carousel :interval="5000" indicator-position="none" type="card" height="315px" arrow="always">
              <el-carousel-item>
                <router-link :to="{path:'/'}">
                  <img src="http://www.qdkeyue.com/uploads/image/20190507/1557226342.jpg">
                  <p>安川</p>
                </router-link>
              </el-carousel-item>
              <el-carousel-item>
                <router-link :to="{path:'/'}">
                  <img src="http://www.qdkeyue.com/uploads/image/20190507/1557220965.jpg">
                  <p>三菱</p>
                </router-link>
              </el-carousel-item>
              <el-carousel-item>
                <router-link :to="{path:'/'}">
                  <img src="http://www.qdkeyue.com/uploads/image/20190507/1557224793.jpg">
                  <p>三洋</p>
                </router-link>
              </el-carousel-item>
              <el-carousel-item>
                <router-link :to="{path:'/'}">
                  <img src="http://www.qdkeyue.com/uploads/image/20190507/1557219608.jpg">
                  <p>松下</p>
                </router-link>
              </el-carousel-item>
              <el-carousel-item>
                <router-link :to="{path:'/'}">
                  <img src="http://www.qdkeyue.com/uploads/image/20190507/1557226126.jpg">
                  <p>西门子</p>
                </router-link>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="index_doubt">
        <div class="center">
          <div class="index_title">
            <div class="h6">咨询服务</div>
            <p>您的问题是我们前进的动力，我们会及时回复！</p>
          </div>
          <el-form ref="formData" :rules="rules" :model="formData" label-width="108px">
            <div class="input">
              <el-form-item label="您的姓名：" prop='name'>
                <el-input v-model="formData.name" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
              <el-form-item label="电话：" prop='tel'>
                <el-input v-model="formData.tel" placeholder="请输入您的手机号"></el-input>
              </el-form-item>
              <el-form-item label="E-mail：" prop='email'>
                <el-input v-model="formData.email" placeholder="请输入您的E-mail"></el-input>
              </el-form-item>
              <div class="clear"></div>
            </div>
            <el-form-item label="您的问题：" prop='content'>
              <el-input type="textarea" v-model="formData.content" placeholder="请输入您相对我们说的话"></el-input>
            </el-form-item>
            <div class="float_r dianhau">
              <div class="p1">温馨提示：</div>
              <div class="p2">您的问题我们会及时回复，如果客户问题较多，回复不及时，请您拨打免费服务热线：<span>400-040-7890</span></div>
              <div class="button">
                <a href="javascript:;" class="float_l" @click="Reset('formData')">重 置</a>
                <a href="javascript:;" class="float_r" @click="Submit('formData')">提 交</a>
                <div class="clear"></div>
              </div>
            </div>
          </el-form>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'

export default {
  name: 'Repair',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      qyloading: false,
      rules: {
        name: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入您的手机号', trigger: 'blur' }],
        content: [{ required: true, message: '请输入您相对我们说的话', trigger: 'blur' }]
      },
      formData: {
        name: '',
        tel: '',
        email: '',
        content: ''
      },
      showinfo: 1
    }
  },
  mounted () {
  },
  methods: {
    click_tab (e) {
      this.showinfo = e
    },
    Reset (formData) {
      this.$refs[formData].resetFields()
    },
    Submit (formData) {
      this.$refs[formData].validate((valid) => {
        if (valid) {
          console.log(this.formData)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.index_about {
  height: 730px;
  position: relative;
  background: #f5f5f5;
}
.index_about .img_bj {
  height: 730px;
  width: 60%;
  max-width: 1064px;
  position: absolute;
  right: 0;
  top: 0;
  background: url(../../assets/repair/img_bj.png) center center no-repeat;
  z-index: 1;
}
.index_about .about {
  width: 55%;
  max-width: 1064px;
  position: absolute;
  left: 0;
  top: 119px;
  z-index: 2;
  height: 541px;
  background: #fff;
}
.index_about .about .text {
  width: 625px;
  padding-right: 55px;
}
.index_about .about .text .biaoti {
  font-size: 40px;
  color: #2e2e2e;
  font-weight: 600;
  line-height: 119px;
  margin-top: -119px;
}
.index_about .about .text .biaoti span {
  color: #1a6dba;
}
.index_about .about .text .img {
  width: 100%;
  margin-top: 76px;
  height: 210px;
  overflow: hidden;
}
.index_about .about .text .img img {
  width: 100%;
  transition: all 0.3s ease-in-out;
}
.index_about .about .text .bt {
  font-size: 20px;
  color: #1a6dba;
  font-weight: 600;
  line-height: 56px;
  padding-top: 7px;
}
.index_about .about .text .xian {
  width: 40px;
  height: 1px;
  background: #808080;
  margin-bottom: 14px;
}
.index_about .about .text p {
  font-size: 14px;
  color: #646464;
  line-height: 32px;
  text-align: justify;
}
.index_about .about .more {
  width: 55px;
  height: 55px;
  position: absolute;
  top: 0;
  right: 0;
  transition: all 1s ease-in-out;
  background: url(../../assets/repair/more.png) center center no-repeat;
}
.index_about .about .more:hover {
  border-radius: 50%;
  transform: rotate(540deg);
  -ms-transform: rotate(540deg);
  -moz-transform: rotate(540deg);
  -webkit-transform: rotate(540deg);
  -o-transform: rotate(540deg);
}
.clear {
  clear: both;
}
.index_product {
  padding-bottom: 40px;
}
.center {
  width: 1200px;
  margin: 0 auto;
}
.index_product .index_title .h6 {
  font-size: 40px;
  color: #2e2e2e;
  font-weight: 600;
  line-height: 50px;
  text-align: center;
}
.index_product .index_title .h6 span {
  color: #1a6dba;
}
.index_title p {
  font-size: 16px;
  color: #808080;
  line-height: 30px;
  text-align: center;
}
.index_product .fenlei {
  height: 70px;
  display: flex;
  background: #1a6dba;
  margin-top: 47px;
}
.index_product .fenlei .left {
  width: 237px;
  height: 70px;
  background: url(../../assets/repair/fenlei_bj.png) center center no-repeat;
}
.index_product .fenlei .left p {
  height: 70px;
  line-height: 70px;
  font-size: 24px;
  color: #ffffff;
  font-weight: 600;
  text-indent: 72px;
  background: url(../../assets/repair/fenlei_icon.png) left 20px center no-repeat;
}
.index_product .fenlei .right {
  width: 950px;
  position: relative;
}
.index_product .fenlei .right .item-label {
  margin-left: 70px;
}
.index_product .fenlei .right .item-label .swiper-slide {
  max-width: 140px;
  padding-right: 30px;
  height: 70px;
  line-height: 70px;
  font-size: 16px;
  color: #8fc9ff;
  line-height: 70px;
  text-indent: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  cursor: pointer;
  float: left;
}
.index_product .fenlei .right .item-label .on {
  color: #fff;
  background: url(../../assets/repair/fenlei_icon2.png) left center no-repeat;
}
.index_product .label_page {
  padding-top: 40px;
}
.index_product .label_page_each {
  margin-left: -23px;
}
.index_product .label_page_each a {
  display: block;
  width: 385px;
  height: 388px;
  margin-left: 22px;
}
.float_l {
  float: left;
}
.float_r {
  float: right;
}
.index_product .label_page_each a .img {
  width: 385px;
  height: 288px;
  overflow: hidden;
}
.index_product .label_page_each a .img img {
  width: 385px;
  height: 288px;
  transition: all 0.3s ease-in-out;
}
.index_product .label_page_each a .h6 {
  font-size: 16px;
  color: #232323;
  text-align: center;
  height: 26px;
  line-height: 26px;
  padding-top: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.index_product .label_page_each a .p {
  font-size: 14px;
  color: #939393;
  text-align: center;
  height: 26px;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.index_product .product {
  height: 488px;
  background: #f5f5f5;
  border: solid 1px #d9d9d9;
}
.index_product .product a {
  display: block;
  width: 399px;
  height: 486px;
  transition: all 0.3s ease-in-out;
  background: url(../../assets/repair/product_bj.png) top -486px center no-repeat;
}
.index_product .product a:hover {
  background: url(../../assets/repair/product_bj.png) top center no-repeat;
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.14);
}
.index_product .product a .xq {
  width: 338px;
  margin: auto;
}
.index_product .product a .xq .h6 {
  font-size: 24px;
  color: #333333;
  font-weight: 600;
  line-height: 35px;
  padding-top: 53px;
  height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.index_product .product a .xq .p {
  font-size: 16px;
  color: #666666;
  line-height: 32px;
  margin-bottom: 12px;
}
.index_product .product a .xq .xian {
  width: 36px;
  height: 5px;
  margin-bottom: 43px;
  background: #1a6dba;
}
.index_product .product a .xq .img {
  width: 338px;
  height: 254px;
  overflow: hidden;
}
.index_product .product a .xq .img img {
  width: 338px;
  height: 254px;
  transition: all 0.3s ease-in-out;
}
.advantage {
  height: 725px;
  background: url(../../assets/repair/advantage_bj.png) center center no-repeat;
}
.advantage .center {
  height: 725px;
  position: relative;
}
.advantage .index_title .h6 {
  font-size: 40px;
  color: #2e2e2e;
  font-weight: 600;
  line-height: 50px;
  text-align: center;
  padding-top: 35px;
}
.advantage .index_title .h6 span {
  color: #1a6dba;
  font-size: 50px;
  padding: 0 5px;
}
.index_title p {
  font-size: 16px;
  color: #808080;
  line-height: 30px;
  text-align: center;
}
.advantage .advantage_img {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -376px;
  z-index: 1;
}
.advantage .each_item {
  cursor: pointer;
  width: 352px;
  position: absolute;
  z-index: 2;
}
.advantage .each_item .bt {
  width: 130px;
  height: 130px;
  font-size: 20px;
  color: #333333;
  text-align: center;
  line-height: 130px;
  transition: all 0.3s ease-in-out;
  border-radius: 50%;
}
.advantage .each_item .nr {
  width: 210px;
  font-size: 16px;
  color: #666666;
  line-height: 30px;
  margin-top: 30px;
  transition: all 0.3s ease-in-out;
}
.advantage .each_item1 {
  bottom: 81px;
  left: 2px;
}
.advantage .each_item2 {
  bottom: 278px;
  left: 49px;
}
.advantage .each_item3 {
  top: 161px;
  left: 50%;
  width: 215px;
  margin-left: -113px;
}
.advantage .each_item3 .bt {
  margin: auto;
  margin-bottom: 10px;
}
.advantage .each_item4 {
  bottom: 278px;
  right: 54px;
}
.advantage .each_item5 {
  bottom: 81px;
  right: 3px;
}
.advantage .each_item:hover .bt {
  background: #1a6dba;
  color: #fff;
}
.advantage .each_item:hover .nr {
  color: #1a6dba;
}
.index_service {
  background: #f5f5f5;
  padding-bottom: 50px;
}
.index_service .index_title .h6 {
  font-size: 40px;
  color: #2e2e2e;
  font-weight: 600;
}
.index_service .index_title .h6 span {
  color: #1a6dba;
}
.index_title .h6 {
  font-size: 40px;
  color: #2e2e2e;
  line-height: 50px;
  text-align: center;
  padding-top: 35px;
  font-weight: 600;
}
.index_title p {
  font-size: 16px;
  color: #808080;
  line-height: 30px;
  text-align: center;
}
.index_service .icon .float_l {
  width: 280px;
  height: 280px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  margin-left: 26px;
  border-radius: 150px;
  background: url(../../assets/repair/icon_bj1.png) center center no-repeat;
}
.index_service .icon .float_l img {
  margin: auto;
  margin-top: 50px;
  margin-bottom: 8px;
  display: block;
}
.index_service .icon .float_l p {
  width: 100px;
  margin: auto;
  font-size: 16px;
  color: #ffffff;
  line-height: 24px;
  text-align: center;
}
.index_service .icon1 {
  margin-top: 38px;
}
.index_service .icon1 .float_l {
  margin-left: 26px;
}
.index_service .icon1 .float_l:nth-child(1) {
  margin-left: 0;
}
.index_service .icon2 .float_l {
  margin-top: -130px;
}
.index_service .icon2 .float_l:nth-child(1) {
  margin-left: 152px;
}
.index_service .icon2 .float_l:nth-child(3) p {
  width: 112px
}
.index_service .icon .float_l:hover {
  background: url(../../assets/repair/icon_bj2.png) center center no-repeat;
}
.cooperation .index_title .h6 span {
  color: #1a6dba;
}
.cooperation .certify {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    margin-top: 32px;
}
.cooperation .certify img {
  width: 586px;
  height: 302px;
  border: solid 1px #cfcfcf;
  display: block;
  margin-left: 5px;
}
.cooperation .certify p {
  line-height: 85px;
  padding-top: 0px;
  text-align: center;
  color: #626262;
  font-size: 24px;
  margin: -73px;
}
.index_doubt {
  padding-bottom: 61px;
  background: #f5f5f5;
}
.index_doubt .input {
  margin-top: 50px;
}
.el-form-item{
  float: left;
  width: 33%;
}
.index_doubt >>> .el-form-item__label {
  width: 108px;
  font-size: 16px;
  color: #646464;
  line-height: 58px;
  text-align: right;
  float: left;
}
.index_doubt >>> .el-input__inner{
  width: 300px;
  height: 58px;
  padding: 0 20px;
  font-size: 14px;
  color: #b2b2b2;
  border: solid 1px #cccccc;
  margin-bottom: 20px;
  outline: none;
  background: #fff;
}
.index_doubt >>> .el-textarea__inner {
  width: 695px;
  height: 155px;
  padding: 15px 20px;
  font-size: 14px;
  color: #b2b2b2;
  border: solid 1px #cccccc;
  outline: none;
}
.dianhau {
  width: 370px;
}
.dianhau .p1 {
  font-size: 16px;
  color: #303030;
  padding-left: 10px;
  line-height: 22px;
  padding-left: 24px;
  margin-bottom: 10px;
  background: url(../../assets/repair/wxts.png) left center no-repeat;
}
.dianhau .p2 {
  font-size: 15px;
  color: #646464;
  line-height: 24px;
  margin-bottom: 10px;
}
.dianhau .p2 span {
  font-size: 22px;
  color: #1a6dba;
  font-weight: 600;
}
.dianhau .button .float_l {
  display: block;
  width: 180px;
  height: 60px;
  background: #1a6dba;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  color: #ffffff;
}
.dianhau .button .float_r {
  display: block;
  width: 180px;
  height: 60px;
  background: #f37a04;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/repair/index.vue